export const KOLKATA_PRESENCE_COMPANIES = [
  "GMR Hyderabad International Airport Ltd",
  "Oil India Limited",
  "Numaligarh Refinery Limited",
  "Brahmaputra Cracker and Polymer Limited",
  "North Eastern Electric Power Corporation Limited",
  "Bharat Electronics Limited",
  "Hindustan Aeronautics Limited",
  "Bharat Earth Movers Limited",
  "Indian Space Research Organisation",
  "National Aluminium Company Limited",
  "Odisha Mining Corporation Limited",
  "Barauni Refinery (IOCL)",
  "Bharat Heavy Electricals Limited",
  "South Eastern Coalfields Limited",
  "Bhilai Steel Plant (SAIL)",
  "NTPC Limited (Sipat)",
  "Larsen & Toubro Limited",
  "Reliance Industries Limited (Jamnagar)",
  "Adani Ports and Special Economic Zone Limited",
  "Gujarat State Petronet Limited",
  "Essar Oil Limited",
  "Gujarat Fluorochemicals Limited",
  "Maruti Suzuki India Limited",
  "Jindal Steel & Power Limited",
  "Hero MotoCorp Limited",
  "SJVN Limited",
  "NHPC Limited",
  "Tata Steel Limited",
  "Bokaro Steel Plant (SAIL)",
  "Central Coalfields Limited",
  "Madras Atomic Power Station",
  "Mangalore Refinery and Petrochemicals Limited",
  "Visvesvaraya Iron and Steel Plant (SAIL)",
  "JSW Steel Limited",
  "Rajasthan Atomic Power Station",
  "Bharat Oman Refineries Limited",
  "Northern Coalfields Limited",
  "Tata Motors Limited",
  "Mahindra & Mahindra Limited",
  "Bharat Petroleum Corporation Limited",
  "Hindustan Petroleum Corporation Limited",
  "Rashtriya Chemicals and Fertilizers Limited",
  "Mazagon Dock Shipbuilders Limited",
  "Nuclear Power Corporation of India Limited",
  "Steel Authority of India Limited",
  "GAIL (India) Limited",
  "NTPC Limited",
  "Oil and Natural Gas Corporation Limited",
  "Power Grid Corporation of India Limited",
  "Indian Oil Corporation Limited",
  "JIPMER",
  "Guru Gobind Singh Refinery (HMEL)",
  "Monnet Ispat & Energy Limited",
  "Hindustan Zinc Limited",
  "Cairn India Limited",
  "Neyveli Lignite Corporation Limited",
  "Chennai Petroleum Corporation Limited",
  "Bharat Heavy Electricals Limited (Trichy)",
  "Singareni Collieries Company Limited",
  "Bharat Dynamics Limited",
  "Electronics Corporation of India Limited",
  "NTPC Limited (Rihand, Singrauli)",
  "Banaras Locomotive Works",
  "THDC India Limited",
  "Coal India Limited",
  "Durgapur Steel Plant (SAIL)",
  "IISCO Steel Plant (SAIL)",
  "Haldia Refinery (IOCL)",
  "Garden Reach Shipbuilders & Engineers Limited",
];

/** @deprecated Use KOLKATA_PRESENCE_COMPANIES */
export const KOLKATA_PRESENCE_LOCATIONS = KOLKATA_PRESENCE_COMPANIES;

export const CUSTOMERS = {
  delhi: { city: "New Delhi", name: "Priya Sharma", company: "Infra Solutions Pvt. Ltd.", tags: ["enterprise", "partner"], revenue: "₹8.4 Cr" },
  mumbai: { city: "Mumbai", name: "Ananya Patel", company: "FinEdge Technologies", tags: ["enterprise", "startup"], revenue: "₹12.7 Cr" },
  bengaluru: { city: "Bengaluru", name: "Rohit Naik", company: "CloudStack Innovations", tags: ["startup", "enterprise"], revenue: "₹14.2 Cr" },
  chennai: { city: "Chennai", name: "Meera Iyer", company: "DravidaTech Solutions", tags: ["smb", "partner"], revenue: "₹3.9 Cr" },
  hyderabad: { city: "Hyderabad", name: "Kiran Reddy", company: "CyberSecure Systems", tags: ["enterprise", "partner"], revenue: "₹6.8 Cr" },
  kolkata: { city: "Kolkata", name: "Debapriya Bose", company: "Eastern Commerce Ltd.", tags: ["enterprise"], revenue: "₹4.5 Cr" },
  pune: { city: "Pune", name: "Sneha Kulkarni", company: "Deccan Auto Parts", tags: ["partner"], revenue: "₹3.3 Cr" },
  ahmedabad: { city: "Ahmedabad", name: "Vivek Shah", company: "GujTech Enterprises", tags: ["smb"], revenue: "₹2.1 Cr" },
  jaipur: { city: "Jaipur", name: "Rajesh Meena", company: "PinkCity Retail Co.", tags: ["smb"], revenue: "₹1.2 Cr" },
  lucknow: { city: "Lucknow", name: "Arjun Verma", company: "NorthStar Logistics", tags: ["smb", "startup"], revenue: "₹0.9 Cr" },
  kochi: { city: "Kochi", name: "Arun Nair", company: "Malabar Digital Hub", tags: ["startup"], revenue: "₹1.6 Cr" },
  chandigarh: { city: "Chandigarh", name: "Gurpreet Singh", company: "PunjabAgro Tech", tags: ["smb"], revenue: "₹0.7 Cr" },
  indore: { city: "Indore", name: "Neha Tiwari", company: "Central India Textiles", tags: ["smb", "partner"], revenue: "₹1.8 Cr" },
  nagpur: { city: "Nagpur", name: "Suresh Deshmukh", company: "Orange City Infra", tags: ["smb"], revenue: "₹1.1 Cr" },
  surat: { city: "Surat", name: "Hardik Patel", company: "Diamond City Exports", tags: ["enterprise"], revenue: "₹3.0 Cr" },
};

export const TAG_CLASS = {
  enterprise: "t-ent",
  smb: "t-smb",
  startup: "t-sta",
  partner: "t-par",
};
